module.exports = __webpack_public_path__ + "static/media/67.aa5133c4.png";